export type FindElementType = {
  id?: string | number;
  children?: FindElementType[];
} & unknown;

export const findItemById = (
  items?: FindElementType[],
  id?: string | number,
): FindElementType | null => {
  if (!items || !id) return null;
  for (const item of items) {
    if (String(item.id) === String(id)) {
      return item;
    }
    if (item.children) {
      const found = findItemById(item.children, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const replaceItemById = (
  items?: FindElementType[],
  id?: string | number,
  newItem?: FindElementType,
): FindElementType[] => {
  if (!items || !id || !newItem) return items || [];

  let replaced = false;
  return items.map((item) => {
    if (replaced) return item;
    if (String(item.id) === String(id)) {
      replaced = true;
      return newItem;
    }
    if (item.children) {
      return {
        ...item,
        children: replaceItemById(item.children, id, newItem),
      };
    }
    return item;
  });
};

export const removeItemById = (items: FindElementType[], id: string): FindElementType[] => {
  return items.reduce((acc, item) => {
    if (String(item.id) === id) {
      return acc;
    }
    if (item.children) {
      return [...acc, { ...item, children: removeItemById(item.children, id) }];
    }
    return [...acc, item];
  }, [] as FindElementType[]);
};

export const findParentById = (items: FindElementType[], id: string): FindElementType | null => {
  for (const item of items) {
    if (item.children && item.children.some((child: FindElementType) => child.id === id)) {
      return item;
    }
    if (item.children) {
      const parent = findParentById(item.children, id);
      if (parent) return parent;
    }
  }
  return null;
};
